import React from "react";
import '../Favorites/Favorites.scss';
import { closeAllView,  getInitialStateWithPreviousView,  
     showView, setPreviousModule } from "../../Menu/MenuSide/menuSideSlice";
import { quizSetId, quizSetName, quizLoad, getInitialState } from "../Quiz/quizSlice";
import { setSelectedNoteId, setSelectedNoteName, setSelectedCategory, 
    setSelectedSubCategory, setSelectedNotePrivateStatus} from "../Notes/noteslice";
import { idNoteLoad } from "../../Admin/adminSlice";
import { renderDonutChart } from "../../../utils/donutChartFunction";
const Favorites = (props) => {
   
    const { dispatch } = props;
    //HANDLE QUIZ
    const onClickQuiz = (e) => {


        console.log('WORK SHOW QUIZ');
        dispatch(closeAllView());
    
        const selectedQuizId = Number(e.target.value);
       // console.log(selectedQuizId);
       
        //FIND NAME QUIZ
       const selectedItem = props.authData.favoriteQuizes.find(item => item.quiz_id === selectedQuizId);
       //console.log(selectedQuizName.);
        const selectedQuizName = selectedItem.quiz_name;
        dispatch(getInitialState());
        dispatch(getInitialStateWithPreviousView());
        dispatch(setPreviousModule());
        dispatch(showView("3"));
        
        dispatch(quizSetId(selectedQuizId));
        dispatch(quizSetName(selectedQuizName));
        dispatch(quizLoad(selectedQuizId));
       
        //dispatch(closeFirstContentView());
    }
        //HANDLE NOTE
     const onClickNote = (e) => {
           
        

        const dataNotes = props.dataNotes;    
        console.log('WORK SHOW NOTES');
        dispatch(closeAllView());

        const selectedNoteId = Number(e.target.value);
        
       
        //FIND NAME QUIZ
        const selectedItem = props.authData.favoriteQuizes.find(item => item.quiz_id === selectedNoteId);
       // console.log(props.dataNotes);
       console.log(selectedItem);
        const selectedNoteName = selectedItem.quiz_name;
        console.log(selectedItem.quiz_subcategory);

        const findNote = (dataNotes) => {
            const result = dataNotes.findIndex(item => item.id === selectedNoteId);
            return result;
        };

       //set selected category and subcategory of note
        dispatch(setSelectedCategory(selectedItem.quiz_category));
        dispatch(setSelectedSubCategory(selectedItem.quiz_subcategory));
        dispatch(setSelectedNotePrivateStatus(selectedItem.public));
       
        const noteExist = findNote(dataNotes);
        
        



    //console.log(noteExist);

        if (noteExist === -1) {

            console.log('Load NEW notes');

            dispatch(setSelectedNoteId(selectedNoteId));
            dispatch(setSelectedNoteName(selectedNoteName));
            dispatch(idNoteLoad(selectedNoteId));
           // dispatch(getInitialStateMenu());
           // dispatch(showNotes());
           dispatch(getInitialStateWithPreviousView());
           dispatch(setPreviousModule());
           dispatch(showView(33));
        } else {
            dispatch(setSelectedNoteId(selectedNoteId));
            dispatch(setSelectedNoteName(selectedNoteName));
           // dispatch(getInitialStateMenu());
            //dispatch(showNotes());
            dispatch(getInitialStateWithPreviousView());
            dispatch(setPreviousModule());
            dispatch(showView(33));
        }


        }


   //RENDER TABLE FAVORITES
   const renderFavoritesTable = () => {
    let  data =  props.authData.favoriteQuizes;
    console.log(data);
    return (
        data.map(item => {
            console.log(item);
            return(
                <div className='tr-item' key={item.quiz_id}>
                    <div className="number">{item.quiz_id}</div>
                    <div className="title">{item.quiz_name}</div>
                    <div className="button-block">
                        <div className="td-button"><button className="quiz" value={item.quiz_id} onClick={onClickQuiz}></button></div>
                        <div className="td-button"><button className="note" value={item.quiz_id} onClick={onClickNote}></button></div>
                        {(props.authData.modulesName[1].status || (props.authData.userRole[0].role_id === 1)) ? <div className="td-button"><button className="trouble"></button></div> : null}
                        <div className="donut-chart-container">{renderDonutChart(Math.round(item.quiz_resolved))}</div>
                        <div className="td-center">{Math.round(item.quiz_resolved)}%</div>
                    </div>
                    
                    
                </div>
                )
            })
        )    
   }

    const favoritesView = props.favoritesView;
    if (favoritesView) {
        return (
            <div className="Favorites">
                <p className="main-header">Избранное</p>
                

                    <div className="container">
                        <p className="header">Разделы. (Тесты. Заметки. Вопросы)  </p>
                        
                            
                           
                           
                            
                               {renderFavoritesTable()} 
                            
                        
                    

                </div>

            </div>
        );   
    } else return null;
    
};
export default Favorites;